import React from "react";
import mainHeader from "../../assets/images/main-header.png";
import user1 from "../../assets/images/user1.png";
import user2 from "../../assets/images/user2.png";
import user3 from "../../assets/images/user3.png";
import user4 from "../../assets/images/user4.png";
const AVATAR_IMAGES = [user1, user2, user3, user4];

export default function HeroSection() {
  return (
    <section id="home" className="hl-hero">
      <div className="hl-hero__grid">
        <div className="hl-hero__copy">
          <span className="hl-pill">
            Membership <span>&amp; Pricing</span>
          </span>

          <h1 className="hl-hero__title">
            <span className="hl-hero__title-line">Customize Your Best</span>
            <span className="hl-hero__title-line hl-hero__title-line--accent">
              60 Minute Session
            </span>
          </h1>

          <p className="hl-hero__lead">
            A proven system of recovery therapies and a community built to
            help you relive, recover and perform at your very best.
          </p>

          <div className="hl-hero__ctas">
            <a href="#download" className="hl-btn hl-btn--primary">
              Book Now <i className="bi bi-arrow-right text-dark fs-5" />
            </a>
            <a href="#hl-services" className="hl-btn hl-btn--outline">
              Explore Services
            </a>
          </div>

          <div className="hl-hero__social">
            <div className="hl-avatar-group">
              {AVATAR_IMAGES.map((img, i) => (
                <img key={i} className="hl-avatar" src={img} alt={`Avatar ${i + 1}`} />
              ))}
            </div>
            <p>Join 1000+ members recovering &amp; performing better every week</p>
          </div>
        </div>

        <div className="hl-hero__visual">
          <img src={mainHeader} alt="Recovery scan overview" className="hl-hero__image" />
        </div>
      </div>
    </section>
  );
}
